<template>
  <form class="bg-light" @submit.prevent="$emit('submit')">
    <div class="progress" style="height: 3px">
      <div class="progress-bar bg-secondary" role="progressbar" :style="'width: ' + progress + '%'"></div>
    </div>
    <div class="p-3">
      <slot v-bind:step="step">
        <div class="d-flex justify-content-center my-5" id="dataLoading">
          <fa-icon :icon="['fal', 'atom-alt']" class="loading fa-spin"></fa-icon>
        </div>
      </slot>
      <bs-alert v-if="error" class="alert-danger px-2 py-1 border-0">
        {{ error.message }}
      </bs-alert>
      <slot name="footer">
        <div class="d-flex justify-content-between align-items-center">
          <bs-button type="submit" class="btn-outline-secondary" :submitting="submitting" @click="prev">
            <span>Previous</span>
          </bs-button>
          <bs-button type="submit" class="btn-info" :submitting="submitting" @click="next">
            <span>Next</span>
          </bs-button>
        </div>
      </slot>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BSMultiStep',
  props: ['error', 'steps'],
  data () {
    return {
      step: 1
    }
  },
  computed: {
    ...mapState({
      submitting: state => state.submitting
    }),
    progress () {
      if (this.step === 1) return 0
      return Math.round(((this.step - 1) / (this.steps)) * 100)
    },
    errors () {
      if (this.axiosError) return this.axiosError.errors
      return null
    }
  },
  methods: {
    next () {
      this.$emit('callback', 'beforeStep' + (this.step += 1), (step) => {
        if (step) {
          this.step = step - 1
          this.next()
        } else this.step++
      })
    },
    prev () {
      this.step = Math.max(this.step - 1, 1)
      this.$emit('prev', this.step)
    }
  }
}
</script>
